/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AuditConfigurationResponseLogStream } from './auditConfigurationResponseLogStream';
import type { AuditConfigurationResponseState } from './auditConfigurationResponseState';

export interface AuditConfigurationResponse {
  organization_id: string;
  retention_period_in_days: number;
  state: AuditConfigurationResponseState;
  log_stream?: AuditConfigurationResponseLogStream;
}
